var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardBottomNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.875 15.0004H5.5673V9.11576H10.1827V15.0004H13.875V6.00039L7.875 1.46194L1.875 6.00039V15.0004ZM0.875 16.0004V5.50039L7.875 0.211914L14.875 5.50039V16.0004H9.1827V10.1158H6.5673V16.0004H0.875Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBottomNav);
export default __webpack_public_path__ + "static/media/dashboardBottomNav.8c13aea6aaab9bed4432dcb94af7fd70.svg";
export { ForwardRef as ReactComponent };